import * as React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import MoreIcon from '@mui/icons-material/MoreVert';
import Logo from '../Res/greenLogo.png';
import DesignImage from '../Res/94996043_9901805.jpg';
import Eclipse from '../Res/Eclipse.svg';
import { DarkModeOutlined, DarkModeRounded, Height, Lan, Light, LightMode } from '@mui/icons-material';
import { Grid, Tooltip, Container, Paper, Fade, Card, CardContent } from '@mui/material';
import LoginForm from '../Components/Forms/LoginForm';
import Langue from '../Components/Langue';
import { useTranslation } from 'react-i18next';
import SetCookie from '../Components/Hooks/Cookies/SetCookie';
import GetCookie from '../Components/Hooks/Cookies/GetCookie';
import Data from "../Data/Data.json"
import Mode from '../Components/Mode';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  alignItems: 'flex-start',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  background: 'transparent',
  backdropFilter: 'blur(10px)',
  '@media all': {
    minHeight: 80,
  },
}));

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  background: 'transparent',
  boxShadow: 'none',
  backdropFilter: 'blur(10px)',
}));

const MainContainer = styled(Container)(({ theme }) => ({
  minHeight: 'calc(100vh - 160px)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  position: 'relative',
}));

const IllustrationSection = styled(Box)(({ theme }) => ({
  flex: '1',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  background: 'linear-gradient(135deg, rgba(176, 210, 247, 0.05) 0%, rgba(176, 210, 247, 0.1) 100%)',
  position: 'relative',
  overflow: 'hidden',
    '&::before': {
    content: '""',
    position: 'absolute',
    top: '-50%',
    right: '-50%',
    width: '200%',
    height: '200%',
    background: 'radial-gradient(circle, rgba(176, 210, 247, 0.08) 0%, transparent 70%)',
    animation: 'float 8s ease-in-out infinite',
  },
}));

const StyledIllustration = styled('img')(({ theme }) => ({
  maxWidth: '100%',
  height: 'auto',
  maxHeight: '400px',
  filter: 'drop-shadow(0 10px 30px rgba(176, 210, 247, 0.2))',
  animation: 'float 6s ease-in-out infinite',
  transition: 'transform 0.3s ease',
  '&:hover': {
    transform: 'scale(1.02)',
  },
}));


export default function Login() {
  const cookieMode = GetCookie(Data.LocalVariable.mode);
  const {t, i18n} = useTranslation();
  const [mode, setmode] = React.useState(cookieMode? cookieMode.toString(): ()=>{
    SetCookie(Data.LocalVariable.mode, 'light')
    return "light"
  })

  const Theme = styled(Box)(({ theme }) => ({
    minHeight: '100vh',
    backgroundImage: (mode == "light") 
      ? 'linear-gradient(135deg, #f8fafb 0%, #ffffff 40%, rgba(176, 210, 247, 0.03) 100%)'
      : 'linear-gradient(135deg, #0a0f1a 0%, #1a2332 60%, rgba(176, 210, 247, 0.05) 100%)',
    color: (mode == "light") ? '#1a1a1a' : '#f1f1f1',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: '10%',
      left: '5%',
      width: '300px',
      height: '300px',
      borderRadius: '50%',
      background: mode === 'light' 
        ? 'radial-gradient(circle, rgba(176, 210, 247, 0.04) 0%, transparent 70%)'
        : 'radial-gradient(circle, rgba(176, 210, 247, 0.08) 0%, transparent 70%)',
      filter: 'blur(60px)',
      animation: 'float 10s ease-in-out infinite',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '15%',
      right: '8%',
      width: '250px',
      height: '250px',
      borderRadius: '50%',
      background: mode === 'light' 
        ? 'radial-gradient(circle, rgba(176, 210, 247, 0.03) 0%, transparent 70%)'
        : 'radial-gradient(circle, rgba(176, 210, 247, 0.06) 0%, transparent 70%)',
      filter: 'blur(40px)',
      animation: 'float 8s ease-in-out infinite reverse',
    },
  }));
  
  const FormTheme = styled(Box)(({ theme }) => ({
    backgroundColor: (mode == "light")? 'rgba(255, 255, 255, 1)' : "rgba(0, 0, 0, 1)",
    color: (mode == "light")?'#333': '#f1f1f1',
    borderRadius: '10px',
    boxShadow: (mode == "light")? "0px 10px 30px rgba(0, 0, 0, 0.127)" : "0px 10px 30px rgba(255, 255, 255, 0.127)",
  }));
  return (
    <Fade in={true} timeout={1000}>
      <Theme sx={{ flexGrow: 1 }} className='full'>
        <StyledAppBar position="static">
          <StyledToolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ 
                mr: 2, 
                transition: 'transform 0.2s ease-in-out', 
                '&:hover': { transform: 'scale(1.05)' } 
              }}
            >
              {/* <img 
                src={Logo} 
                width="70" 
                alt="Logo" 
                style={{ 
                  filter: mode === 'dark' ? 'brightness(1.2) contrast(1.1)' : 'none',
                  transition: 'filter 0.3s ease'
                }} 
              /> */}
            </IconButton>
            <Typography
              variant="h5"
              noWrap
              component="div"
              sx={{ 
                flexGrow: 1, 
                alignSelf: 'flex-end',
                fontWeight: 600,
                letterSpacing: '0.5px',
                background: mode === 'light' 
                  ? '#3C81CD'
                  : 'linear-gradient(135deg, #6FAFEF, #3B8FD8)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {t("texte.bienvenue")}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Langue />
              <Mode />
            </Box>
          </StyledToolbar>
        </StyledAppBar>
        
        <MainContainer maxWidth={false}>
          <Card 
            elevation={0}
            sx={{
              display: 'flex',
              borderRadius: '24px',
              overflow: 'hidden',
              boxShadow: mode === 'light' 
                ? '0 20px 60px rgba(0, 0, 0, 0.08), 0 8px 20px rgba(0, 0, 0, 0.06)'
                : '0 20px 60px rgba(0, 0, 0, 0.4), 0 8px 20px rgba(0, 0, 0, 0.3)',
              background: mode === 'light' 
                ? '#B0D2F7'
                : 'rgba(30, 30, 30, 0.98)',
              backdropFilter: 'blur(20px)',
              maxWidth: '1200px',
              width: '100%',
              minHeight: '600px',
              transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: mode === 'light' 
                  ? '0 30px 80px rgba(0, 0, 0, 0.12), 0 12px 30px rgba(0, 0, 0, 0.08)'
                  : '0 30px 80px rgba(0, 0, 0, 0.5), 0 12px 30px rgba(0, 0, 0, 0.4)',
              },
            }}
          >
            <IllustrationSection>
              <StyledIllustration 
                src={DesignImage} 
                alt="Illustration"
                style={{
                  filter: mode === 'dark' 
                    ? 'drop-shadow(0 10px 30px rgba(176, 210, 247, 0.3)) brightness(1.1)'
                    : 'drop-shadow(0 10px 30px rgba(176, 210, 247, 0.2))'
                }}
              />
            </IllustrationSection>
            
            <Box 
              sx={{
                flex: '1',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: (theme) => theme.spacing(4),
                background: mode === 'light' ? '#ffffff' : 'rgba(20, 20, 20, 0.98)',
              }}
            >
              <Box sx={{ width: '100%',}}>
                <LoginForm mode={mode === "light" ? "light" : "dark"} />
              </Box>
            </Box>
          </Card>
        </MainContainer>
        
        <Box 
          sx={{ 
            textAlign: 'center', 
            py: 2, 
            position: 'relative',
            zIndex: 1
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              color: mode === 'light' ? 'rgba(0, 0, 0, 0.5)' : 'rgba(255, 255, 255, 0.6)',
              fontSize: '0.875rem',
              letterSpacing: '0.5px',
              fontWeight: 400,
            }}
          >
            {t("texte.copyright")} · {t("texte.version")}
          </Typography>
        </Box>
      </Theme>
    </Fade>
  );
}

